import React from 'react';
import PropTypes from 'prop-types';
import className from 'classnames';
import { withContext } from './Context';
import { DateUtils } from '../../utils/DateUtils';
import { ExtraContentProp, withCalendarExtraContentContext } from './Context/Context';
import { ABUtils } from '../../utils';

// eslint-disable-next-line max-statements
const Day = ({ date, context, extraContent }) => {
    const { isPricesInCalendarActive: hasFaresInCalendar } = ABUtils.getABs();
    const getHolidaysClassNames = () =>
        className({
            'odf-calendar-day-holiday': isCountryHoliday(),
            'odf-calendar-day-holiday-region': isRegionHoliday(),
        });

    const getDayClassNames = () => {
        const sameMonth = context.displayMonth.getMonth() === date.getMonth();
        const currentDateIsOnDates =
            sameMonth && context.dates.find((d) => DateUtils.compare(d, date) === 0);

        return className({
            'active': currentDateIsOnDates,
            'disabled': isDisabled(),
            'odf-calendar-day': true,
            'odf-calendar-day-weekend': DateUtils.isWeekend(date),
            'odf-calendar-day-start': isStartDay(),
            'odf-calendar-day-end': isEndDay(),
            'odf-calendar-day-selected': isSelected(),
            'odf-calendar-day-range': isInRange(),
            'odf-calendar-day-round': isSameDayRoundTrip(),
        });
    };

    const isDisabled = () => {
        const sameMonth = context.displayMonth.getMonth() === date.getMonth();
        return (
            !sameMonth ||
            DateUtils.compare(context.minDate, date) === -1 ||
            DateUtils.compare(context.maxDate, date) === 1
        );
    };

    const isSelected = () => {
        const isSelectedDate = DateUtils.compare(context.selectedDate, date) === 0;
        const sameMonth = context.displayMonth.getMonth() === date.getMonth();
        return !context.isDatesRangeShown && sameMonth && isSelectedDate;
    };

    const isSameDayRoundTrip = () => {
        const isStartAndEnd = isStartDay() && isEndDay();
        return context.isDatesRangeShown && isStartAndEnd;
    };

    const isStartDay = () => {
        const sameMonth = context.displayMonth.getMonth() === date.getMonth();
        const startDate = context.dates.length && context.dates[0];
        return context.isDatesRangeShown && sameMonth && DateUtils.compare(date, startDate) === 0;
    };

    const isEndDay = () => {
        const sameMonth = context.displayMonth.getMonth() === date.getMonth();
        const endDate = context.dates.length > 1 && context.dates[context.dates.length - 1];
        return context.isDatesRangeShown && sameMonth && DateUtils.compare(date, endDate) === 0;
    };

    const isInRange = () => {
        const startDate = context.dates.length && context.dates[0];
        const endDate = context.dates.length > 1 && context.dates[context.dates.length - 1];
        return (
            context.isDatesRangeShown &&
            DateUtils.compare(date, startDate) < 0 &&
            DateUtils.compare(date, endDate) > 0
        );
    };

    const isCountryHoliday = () => {
        return isHoliday(context.countryHolidays);
    };

    const isRegionHoliday = () => {
        return isHoliday(context.regionHolidays);
    };

    const isHoliday = (list) => {
        const isDisplayMonth = context.displayMonth.getMonth() === date.getMonth();
        return isDisplayMonth && list.some((holiday) => DateUtils.compare(holiday, date) === 0);
    };

    const sameMonth = context.displayMonth.getMonth() === date.getMonth();
    const content = sameMonth ? date.getDate() : '';

    const classNames = getDayClassNames();
    const holidayClassNames = getHolidaysClassNames();
    const showHoliday = !!holidayClassNames && !hasFaresInCalendar;
    const disabled = isDisabled();
    const ExtraContent = extraContent.ExtraContent;

    const onClick = () => {
        extraContent.onClick(date, context.type);
        context.onSelect(date);
    };

    return (
        <div className={classNames} onClick={() => !disabled && onClick()}>
            {showHoliday && <div className={holidayClassNames} />}
            {content}
            <ExtraContent date={date} calendarType={context.type} isDayDisabled={isDisabled()} />
        </div>
    );
};

Day.propTypes = {
    date: PropTypes.instanceOf(Date).isRequired,
    context: PropTypes.object.isRequired,
    extraContent: ExtraContentProp.isRequired,
};

const dayWithContext = withCalendarExtraContentContext(withContext(Day));
export { dayWithContext as Day };
